export const getters = {
  fluxs (state) {
    return state.fluxs
  },
  flux (state) {
    return state.flux
  },  
  pagination(state){
    return state.pagination
  }
}
